module.exports = __webpack_public_path__ + "static/media/flos.b206195c.JPG";